import { useLazyQuery } from "@apollo/client/react";
import { useCallback, useMemo } from "react";

import rethrowIfNotAborted from "apollo/rethrowIfNotAborted";

import { AI_INTEGRATION_PROVIDER_BEDROCK } from "../constants";
import { AVAILABLE_AI_MODELS } from "./gql";

type LoadModelsArgs = {
  provider: string | undefined;
  apiKey: string;
  baseURL: string;
  space: string | undefined;
};

const useAiIntegrationAvailableModels = () => {
  const [loadAvailableModels, { data, previousData, error, loading, called }] =
    useLazyQuery(AVAILABLE_AI_MODELS);

  const loadModels = useCallback(
    ({ provider, apiKey, baseURL, space }: LoadModelsArgs) => {
      if (!provider || provider === AI_INTEGRATION_PROVIDER_BEDROCK || apiKey === "") {
        return;
      }

      loadAvailableModels({
        context: { suppressFlashError: true },
        variables: {
          provider,
          apiKey,
          baseURL: baseURL || null,
          space: space || null,
          providerConfig: null,
          providerIntegrationId: null,
        },
      }).catch(rethrowIfNotAborted);
    },
    [loadAvailableModels]
  );

  const models = useMemo(
    () => data?.availableAIModels || previousData?.availableAIModels || [],
    [data, previousData]
  );

  return { models, error, loading, called, loadModels };
};

export default useAiIntegrationAvailableModels;
